<template>
<div>
	<div v-if="step == 0">
		<h3>Do you work with unionized employees?</h3>

		<div class="d-flex flex-row justify-content-center">
			<button class="btn btn-lg btn-light m-1" v-on:click="hasUnions = true;step = 1">
				YES
			</button>
			<button class="btn btn-lg btn-light m-1" v-on:click="$emit('doneSection',)">
				NO
			</button>
		</div>
	</div>
	<div v-else-if="step == 1">

		<div class="alert alert-info">
			<i class="fa fa-info-circle"></i>
			<p style="font-size: 16pt;font-weight: 300;">Create a list of the unions you work with. We'll add details to them later</p>
		</div>

		<table-list record-name="Compensation Group/Union"
			:fields="[{key: 'union_name',label:'Compensation Group/Union Name'}]"
			:has-delete="true"
			delete-endpoint="Union/delete"
			:records="$store.unions"
			:hide-record-count="true"
			v-on:modelChange="fetchUnions">

			<form-group label="Add Union"
				class="add-to-list-text"
				col-class="stacked">
				<div class="d-flex flex-row">
					<field v-model="unionName" :focus="unionFocus"></field>
					<button type="button" class="btn btn-success" v-on:click="saveUnion">Add</button>
				</div>
			</form-group>

		</table-list>

	</div>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import TableList from "@/components/TableList"

export default {
	name: "UnionList",
	components: {
		Field,
		TableList,
		FormGroup
	},
	data() {
		return {
			step: 0,
			hasUnions: null,
			unionName: "",
			unionFocus: 1
		}
	},
	methods: {
		saveUnion() {
			let vm = this
			if (this.unionName != "") {
				this.postData("Union/save",{union_name: this.unionName},true).then(response => {
					if (response.success) {
						vm.unionName = ""
						vm.setUnionFocus()
						vm.fetchUnions()
					}
				})	
			}
		},
		setUnionFocus() {
			this.unionFocus++
		}
	},
	created() {
		let vm = this
		this.fetchUnions().then(response => {
			if (response.success && response.data.length > 0)
				vm.step = 1
		})
	}
}
</script>

<style scoped>
	.list-group-item-action {
		cursor: pointer;
	}
</style>